import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-aae238c4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    ref: "editorContainerRef",
    class: "date-input-container"
};
const _hoisted_2 = { class: "input-left-container" };
const _hoisted_3 = { class: "datepicker-container" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FriedIcon = _resolveComponent("FriedIcon");
    const _component_EditorContent = _resolveComponent("EditorContent");
    const _component_FriedFieldSet = _resolveComponent("FriedFieldSet");
    const _component_FriedDatePicker = _resolveComponent("FriedDatePicker");
    const _component_FriedButton = _resolveComponent("FriedButton");
    const _component_FriedDropdown = _resolveComponent("FriedDropdown");
    return (_openBlock(), _createBlock(_component_FriedDropdown, {
        open: _ctx.open,
        "onUpdate:open": _cache[1] || (_cache[1] = ($event) => ((_ctx.open) = $event)),
        class: _normalizeClass(['input-date', { editable: _ctx.editable }]),
        disabled: !_ctx.editable,
        "close-on-action": false,
        "main-axis-offset": 0,
        "cross-axis-offset": 4
    }, {
        trigger: _withCtx(() => [
            _createVNode(_component_FriedFieldSet, {
                id: _ctx.inputField.id,
                ref: "dateInputBoxRef",
                class: "input-editor-container",
                tabindex: 0,
                "data-external": "date-input-field-input",
                onDrop: _cache[0] || (_cache[0] = _withModifiers(() => { }, ["stop", "prevent"]))
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _createVNode(_component_FriedIcon, {
                                class: "icon-left",
                                icon: "calendar-edit",
                                size: _ctx.IconSize.Small
                            }, null, 8, ["size"]),
                            _createVNode(_component_EditorContent, {
                                editor: _ctx.editor,
                                spellcheck: "false"
                            }, null, 8, ["editor"])
                        ]),
                        _createElementVNode("div", {
                            class: _normalizeClass(['select-chevron', { open: _ctx.open }])
                        }, [
                            _createVNode(_component_FriedIcon, { icon: "chevron-down" })
                        ], 2)
                    ], 512)
                ]),
                _: 1
            }, 8, ["id"])
        ]),
        content: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_FriedDatePicker, {
                    "model-value": _ctx.selectedMediumDate,
                    "onUpdate:modelValue": _ctx.handleDateSelect
                }, null, 8, ["model-value", "onUpdate:modelValue"]),
                _createVNode(_component_FriedButton, {
                    "data-external": "date-input-field-clear-date-button",
                    "button-type": _ctx.ButtonType.Secondary,
                    disabled: !_ctx.fieldValue,
                    class: "clear-button",
                    onClick: _ctx.handleClear
                }, {
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t('date_input_clear_date')), 1)
                    ]),
                    _: 1
                }, 8, ["button-type", "disabled", "onClick"])
            ])
        ]),
        _: 1
    }, 8, ["open", "class", "disabled"]));
}
